import { render } from "./InternalExternalIP.vue?vue&type=template&id=14642e87&scoped=true"
import script from "./InternalExternalIP.vue?vue&type=script&lang=js"
export * from "./InternalExternalIP.vue?vue&type=script&lang=js"

import "./InternalExternalIP.vue?vue&type=style&index=0&id=14642e87&lang=scss&scoped=true"

import exportComponent from "../../../../../github.com:rancher/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14642e87"]])

export default __exports__